export const storageConstants = {
    USER: 'USER',
    TEMP_ORDER: 'TEMP_ORDER',
    TTL: 7200,
    LANGUAGE: 'LANGUAGE',
    PERMISSIONS: 'PERMISSIONS'
};
